"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesInjection = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var cache_1 = __importDefault(require("@emotion/cache"));
var react_1 = require("@emotion/react");
exports.StylesInjection = function (props) {
    // @emotion/cache only accept alpha characters
    // Don't use shortid because it doesn't support less than 64 unique characters (See https://github.com/dylang/shortid#shortidcharactersstring)
    // Later we will use nanoid
    var uniqueAlphaCharacterId = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 10);
    var emotionCache = cache_1.default({
        key: uniqueAlphaCharacterId,
        container: props.injectionPoint
    });
    return (React.createElement(styled_components_1.StyleSheetManager, { target: props.injectionPoint },
        React.createElement(react_1.CacheProvider, { value: emotionCache }, props.children)));
};
